import { DatePipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportsTheme, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { ListItemComponent } from '@frontend/sports/common/ui/sports-list-items';
import { CalendarUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { EpcotNotificationComponent } from '../epcotNotifications/notification.component';

@Component({
    selector: 'ms-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    imports: [DatePipe, EpcotNotificationComponent, IconCustomComponent, ListItemComponent],
})
export class ErrorComponent {
    sitecore = inject(Sitecore);
    private epcotConfig = inject(EpcotConfig);

    @Input() message?: string;
    @Input() severity?: string;
    @Input() links = true;
    @Input({ required: false }) arrow = true;

    today: Date = new Date();
    visible = true;
    liveUrl: string;
    todayUrl: string;
    allUrl: string;
    homeUrl: string;
    epcotEnable: boolean;
    iconSize: string;
    readonly currentTheme = injectCurrentTheme();
    readonly brazilThemes: SportsTheme[] = ['betboo-br', 'sportingbet-br'];

    constructor() {
        const urlHelper = inject(UrlHelperService);

        this.liveUrl = urlHelper.getLiveUrl();
        this.todayUrl = urlHelper.getCalendarUrl(CalendarUrlParam.Today);
        this.allUrl = urlHelper.getSportUrl();
        this.homeUrl = urlHelper.getHomeUrl();
        this.epcotEnable = this.epcotConfig.isEnabled;
        this.iconSize = this.brazilThemes.includes(this.currentTheme) || !this.epcotEnable ? '16' : '24';
    }

    get getIconName() {
        return this.severity === 'info' ? 'theme-info-i' : 'theme-error-i';
    }
}
